import { createContext } from "react";
// creating a new context api
const noteContext = createContext();
export default noteContext;